<template src="./messageConvrestaionListComponent.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "messageConvrestaionListComponent",
        props: [],
        data() {
            return {
                unreadMessages: false,
                allMessages: true,
                notrespondMessages: false,
                currResObj: {},
                messagesList: [],
                conversationId: null,
                messagesCount: {
                    AllMessages: 0,
                    Unread: 0,
                    NotResponded: 0
                },
                messageFilterType: "all",
                reservationId: "",
                formats: {
                    sameDay: 'hh:mm A',
                    nextDay: 'hh:mm A',
                    nextWeek: 'ddd MM/DD',
                    lastDay: 'ddd hh:mm A',
                    lastWeek: 'ddd hh:mm A',
                    sameElse: 'DD MMM YYYY'
                },
                loading: true,
                showConversations: false,
                apiUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : ""),
                customViewList: [],
                viewList: [
                    { Label: 'All Reservations', ViewListId: -1, IsChecked: 0, isSortLoading: false },

                    { Label: 'All Inquiries and Request', ViewListId: -7, IsChecked: 0, isSortLoading: false },
                    // { Label: 'All Request Reservations', ViewListId: -8, IsChecked: 0, isSortLoading: false },
                    { Label: 'All Reserved Reservations', ViewListId: -9, IsChecked: 0, isSortLoading: false },

                    { Label: 'Currently In House', ViewListId: -2, IsChecked: 0, isSortLoading: false },
                    { Label: 'Arriving Today', ViewListId: -3, IsChecked: 0, isSortLoading: false },
                    { Label: 'Departing Today', ViewListId: -4, IsChecked: 0, isSortLoading: false },
                    { Label: 'Upcoming Reservations', ViewListId: -5, IsChecked: 1, isSortLoading: false },
                    { Label: 'Today’s Reservations', ViewListId: -6, IsChecked: 0, isSortLoading: false },
                ],
                ViewListId: -1,
                messageSelectedFilterColumn: null,
                messageUnitList: [],
                messageShowunitNameList: false,
                messageFilterSearchUnitNameText: null,
                messageFilterObj: {
                    PropertyId: -99,
                    UnitClassId: -99,
                    ViewListId: -5,
                    SortBy: null,
                    SortOrder: null,
                    resSourceId: -99,
                    TagsList: [],
                    SearchText: [],
                    Properties: [],
                    UnitClasses: [],
                    UnitTypes: [],
                    Sources: [],
                    Units: [],
                    UnitIds: [],
                    StatusList: [],
                    Columns: [],
                    PageNumber: 1,
                    ItemsPerPage: 20,
                    resid: null,
                    userDate: moment().format("YYYY-MM-DD"),
                    showUnAllocatedReservations: false,
                    includeObsoleteInventory: false
                },
                messageSearchText: "",
                noResult: false,
                options: {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    probeType: 3,
                    mouseWheel: true,
                    mouseWheelSpeed: 1
                },
                variable: false,
                totalLength: null,
                pullDownTextObj: {
                    trigger: 'Loading...',
                    begin: 'Loading...',
                    complete: 'There are no items',
                    error: 'There is server error',
                    refresh: 'Loading...'
                },
                PageNumber: 1
            }
        },
        updated() {
            var messageSearchResultsAmenitiesDivId = document.getElementById("messageSearchResultsAmenitiesDiv")
            messageSearchResultsAmenitiesDivId.scrollTop = messageSearchResultsAmenitiesDivId.scrollHeight - messageSearchResultsAmenitiesDivId.clientHeight
        },
        methods: {
            getMoreData($stateChange) {
                if (this.messagesList.length >= this.totalLength) {
                    $stateChange('complete')
                } else {
                    this.loading = false;
                    this.PageNumber++;
                    vm.GetConversationList(null, 'filterData', vm.ViewListId);
                }
            },
            refreshData($pullStateChange) {
                setTimeout(() => {
                    this.messagesList.splice(0)
                    for (let i = 0; i < 50; i++) {
                        this.messagesList.push({
                            text: i,
                            id: i,

                        })
                    }
                    $pullStateChange('complete')
                }, 1500)
            },
            Searchtext(value) {
                let vm = this;
                if (((value.which <= 90 && value.which >= 48) || value.which == 8 || value.which == 46) && value.code != "MetaLeft") {
                    clearTimeout(vm.timeout);
                    vm.timeout = setTimeout(function () {
                        console.log("value.which", value)
                        vm.searching = true;
                        vm.reRender = false;
                        vm.loading = true;
                        vm.GetConversationList(null, 'filterData', vm.ViewListId);
                        vm.conversationId = null
                        vm.showConversations = false
                        vm.reservationId = null;
                    }, 2000);
                }
            },
            clearMessageSearchText() {
                let vm = this;
                // location.reload() 
                // this.$forceUpdate ();        
                if (vm.messageSearchText != null && vm.messageSearchText != '') {
                    // vm.items = [];
                    vm.messageSearchText = "";
                    vm.searching = true;
                    vm.reRender = false;
                    vm.loading = true;
                    vm.GetConversationList(null, 'filterData', vm.ViewListId);
                }
            },
            applyMessageFilter() {
                let vm = this;
                vm.GetConversationList(null, 'filterData', vm.ViewListId);
                vm.conversationId = null
                vm.showConversations = false
                vm.reservationId = null;
                setTimeout(function () {
                    console.log("Closing the panel");
                    $(".messageUnit").removeClass("show");
                }, 10);
            },
            closeMessageFilterPanel() {
                $(".messageUnit").removeClass("show");
            },
            clearAllMessageFilters() {
                let vm = this;
                vm.messageFilterObj.Units = [];
                vm.messageFilterObj.UnitIds = [];
                vm.clearMessageFilter();
                vm.ViewListId = "-1";
                vm.GetConversationList(null, 'filterData', vm.ViewListId);
            },
            clearMessageFilter() {
                let vm = this;
                vm.messageUnitList = [];
                vm.messageShowunitNameList = false;
            },
            messageShowFilterByType(filterCol) {
                let vm = this;
                vm.messageShowunitNameList = true;
                setTimeout(function () {
                    vm.messageSelectedFilterColumn = filterCol;

                    if (filterCol == "unitName") {
                        vm.getUnitNamesBySearchText();
                        $("#messageUnitNameDropDown").show();
                    }
                }, 10);
            },
            UpdateMessageStatus(conversationId) {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "UpdateMessageStatus",
                    params: {
                        ConversationId: conversationId,
                        StatusId: 1
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("UpdateMessageStatus", err);
                            return;
                        }
                        if (response) {
                            console.log("response in UpdateMessageStatus", response);
                            vm.panelCallback({ conversationId: conversationId });
                        }
                    }
                });
            },
            changeToAllorUnreadOrNotrespondList(listType) {
                let vm = this;
                vm.messageFilterType = listType;
                console.log("vm.messageFilterType = ", vm.messageFilterType)
                vm.GetConversationList(null, "", vm.ViewListId)
                vm.currResObj = {};
                vm.reservationId = null;
                vm.conversationId = null;
                vm.showConversations = false
                let messageList = []
                if (listType == 'all') {
                    vm.UpdateMessageStatus(vm.conversationId)
                    messageList = vm.messagesList
                }
                else if (listType == 'unread') {
                    messageList = vm.messagesList.filter(message => !message.IsMessagesRead)
                }
                else if (listType == 'notResponded') {
                    vm.UpdateMessageStatus(vm.conversationId)
                    messageList = vm.messagesList.filter(message => !message.IsMessageReplied)
                }
                $(".list-group-item").scrollTop(0);
                if (messageList.length == 0) {
                    vm.noResult = true;
                } else {
                    vm.noResult = false;
                }
            },
            GetConversationList(conversationId, filterData, ViewListId) {
                let vm = this;
                if (filterData == 'filterData') {
                    vm.loading = true;
                }
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetConversationList",
                    params: {
                        conversationId,
                        ViewListId: ViewListId,
                        UnitsList: vm.messageFilterObj.UnitIds.length > 0 ? vm.messageFilterObj.UnitIds.toString() : "",
                        SearchText: vm.messageSearchText,
                        PageNo: vm.PageNumber,
                        ItemsPerPage: 20
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetConversationList", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetConversationList", response[2][0]);
                            vm.$store.commit("setRefreshMessageNotificationPanel", false);
                            if (conversationId) {
                                let index = vm.messagesList.findIndex(x => x.ConversationId == conversationId);
                                vm.messagesList[index] = response[2][0]
                                vm.messagesList[index]["replyUsersList"] = response[3]
                            }
                            else {
                                for (let conversation of response[2]) {
                                    let sortedUserList = response[3].sort((a, b) => (a.datecreated < b.datecreated ? 1 : -1));
                                    let replyUserlist = response[3].filter(user => user.ConversationId == conversation.ConversationId)
                                    conversation["replyUsersList"] = replyUserlist
                                }
                                vm.messagesList.splice(0, vm.messagesList.length, ...response[2]);
                                vm.loading = false
                                vm.messagesCount = response[1][0]
                                let messageList = []
                                if (vm.messageFilterType == "unread") {
                                    messageList = vm.messagesList.filter(message => !message.IsMessagesRead)
                                    vm.totalLength = vm.messagesCount.Unread
                                }
                                else if (vm.messageFilterType == "notResponded") {
                                    messageList = vm.messagesList.filter(message => !message.IsMessageReplied)
                                    vm.totalLength = vm.messagesCount.NotResponded
                                }
                                else if (vm.messageFilterType == "all") {
                                    messageList = vm.messagesList
                                    vm.totalLength = vm.messagesCount.AllMessages
                                }
                                console.log("vm.messageFilterType = 1", vm.messageFilterType)
                                console.log("messagelist == ", vm.messagesList)
                                // vm.currResObj = { ReservationId: messageList[0].ReservationId, pagename: "messageInbox" };
                                // vm.reservationId = messageList[0].ReservationId;
                                // vm.conversationId = messageList[0].ConversationId;

                                // if (vm.allMessages) {
                                //     vm.messageFilterType = "all"
                                // } else if (vm.unreadMessages) {
                                //     vm.messageFilterType = "unread"
                                // } else if (vm.notrespondMessages) {
                                //     vm.messageFilterType = "notResponded"
                                // }
                                if (messageList.length == 0) {
                                    vm.noResult = true;
                                } else {
                                    vm.noResult = false;
                                }
                                vm.loading = false
                            }
                        }
                    }
                });
            },
            formatDateTime(date) {
                let vm = this;
                // if (moment(date).isSame(moment(), "day")) {
                //     return moment(date).format('hh:mm A');

                // } else if(moment(date).isSame(new Date(), 'week')){
                //     return moment(date).format('ddd MM/DD');
                // }
                moment.locale('en', {
                    calendar: {
                        lastDay: function () {
                            return 'ddd hh:mm A';
                        },
                        sameDay: function (now) {
                            // if (this.isBefore(now)) {
                            //     return 'ddd hh:mm A';
                            // } else {
                            return 'hh:mm A';
                            // }

                        },
                        nextDay: function () {
                            return 'hh:mm A';
                        },
                        nextWeek: function () {
                            return 'ddd MM/DD';
                        },
                        lastWeek: function () {
                            return 'ddd hh:mm A';
                        },
                        sameElse: function () {
                            return 'DD MMM YYYY';
                        }
                    }
                });
                // moment.lang('en-gb', {
                //     calendar: {
                //         lastDay: 'ddd LT',
                //         sameDay: 'LT',
                //         nextDay: 'LT',
                //         lastWeek: 'ddd LT',
                //         nextWeek: 'dddd LT',
                //         sameElse: 'DD MMM YYYY'
                //     }
                // });
                // let m = moment(date).format("YYYY MMM DD HH:mm:ss")
                console.log("moment.locale == ", moment("2021-05-09T06:21:02.000Z").calendar())
                return moment(date).calendar();
            },
            formatDate(date) {
                let vm = this;
                return moment(date).format("MMM DD");
            },
            showReservationSummayandConversation(resId, conversationId) {
                let vm = this;
                vm.currResObj = { ReservationId: resId, pagename: "messageInbox" };
                vm.reservationId = resId
                vm.conversationId = conversationId;
                vm.showConversations = true
            },
            panelCallback(conversationObj) {
                let vm = this;
                // vm.GetConversationList();
                let index = vm.messagesList.findIndex(x => x.ConversationId == conversationObj.conversationId);
                console.log("messageIndex == ", index)
                if (index > -1) {
                    if (!vm.messagesList[index].IsMessagesRead) {
                        vm.messagesList[index].IsMessagesRead = true
                        vm.messagesCount.Unread = vm.messagesCount.Unread - 1
                        vm.messagesList[index].CountofMessages = null
                    }
                }
                // else if (vm.messageFilterType = "unread") {
                //     vm.GetConversationList();
                // }
            },
            updateConversation(conversationObj) {
                let vm = this;
                // vm.GetConversationList();
                let index = vm.messagesList.findIndex(x => x.ConversationId == conversationObj.conversationId);
                console.log("messageIndex == ", index)
                if (index > -1) {
                    if (!vm.messagesList[index].IsMessageReplied && !vm.notrespondMessages) {
                        vm.messagesList[index].IsMessageReplied = true
                        vm.messagesCount.NotResponded = vm.messagesCount.NotResponded - 1
                        vm.messagesList[index].CountofMessages = null
                    }
                    else if (vm.notrespondMessages && !conversationObj.IsMessageReplied) {
                        vm.messagesCount.NotResponded = vm.messagesCount.NotResponded - 1
                        vm.messagesList[index].CountofMessages = null
                    }
                    // vm.GetConversationList(conversationObj.conversationId)
                    let sortedUserList = conversationObj.repliedUsersList.sort((a, b) => (a.datecreated < b.datecreated ? 1 : -1));
                    vm.messagesList[index].replyUsersList.splice(0, vm.messagesList[index].replyUsersList.length, ...sortedUserList)
                    // let userIndex = vm.messagesList[index].replyUsersList.findIndex(x => x.UserId == vm.$store.state.selectedUserDetail.UserId);
                    // vm.messagesList[index].replyUsersList[userIndex].Countofreply = vm.messagesList[index].replyUsersList[userIndex].Countofreply + 1
                    // vm.messagesList[index].replyUsersList = vm.messagesList[index].replyUsersList.sort((a, b) => (a.Countofreply < b.Countofreply ? 1 : -1));
                }
            },
            resSummarypanelCallback(resObj) {
                let vm = this;
                // this.GetConversationList();
                if (resObj) {
                    console.log("resSummarypanelCallback = ", resObj.StatusId)
                    let statusList = vm.statusList.filter(status => {
                        if (status.StatusId == resObj.StatusId) {
                            return status
                        }
                    })
                    console.log("resSummarypanelCallbac1 = ", statusList)
                    let index = vm.messagesList.findIndex(x => x.ConversationId == vm.conversationId);
                    if (index > -1) {
                        vm.messagesList[index].StatusName = statusList[0].StatusName
                    }
                }
                if (vm.unreadMessages) {
                    vm.UpdateMessageStatus(vm.conversationId)
                }
            },
            GetResevationStatusListBySearchText() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetResevationStatusListBySearchText",
                    params: {
                        searchText: ""
                    },
                    callback: function (err, response) {
                        if (err) {
                            console.log("GetResevationStatusListBySearchText", err);
                            return;
                        }
                        if (response) {
                            console.log("response in GetResevationStatusListBySearchText", response.statusList);
                            vm.statusList = response.statusList
                        }
                    }
                });
            },
            imageURLS(imgGuid) {
                // let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
                // if (isBase64) {
                //     return imgGuid;
                // }
                return this.apiUrl + "/downloadImage/" + imgGuid + "/null";
            },
            getReservationCustomViews() {
                let vm = this;
                this.$store.dispatch("dataRequestHandler", {
                    key: "GetEntityCustomViewList",
                    params: {
                        EntityId: 4
                    },
                    callback: function (err, response) {
                        if (response) {
                            vm.customViewList = response.customViewList;
                        } else {
                            console.log(err);
                        }
                    }
                });
            },
            getUnitNamesBySearchText(searchText) {
                let vm = this;
                let resultObj = vm.messageFilterObj.Properties.map(obj => obj.PropertyId);
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "GetUnitListBySearchText",
                        params: {
                            searchText: searchText,
                            PropertyId: resultObj.toString()
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                let List = response.unitList.filter(function (unitObject) { return unitObject.StatusId == 1 });
                                for (var i = 0; i < vm.messageFilterObj.Units.length; i++) {
                                    console.log("vm.messageFilterObj.Units[i].UnitId", vm.messageFilterObj.Units[i].UnitId)
                                    let index = List.findIndex(x => x.UnitId == vm.messageFilterObj.Units[i].UnitId);
                                    if (index > -1)
                                        List.splice(index, 1);
                                    console.log("index", index);
                                }
                                vm.messageUnitList.splice(0, vm.messageUnitList.length, ...List);
                            }
                        }
                    });
            },
            messageAddUnitToFilter(unitObj) {
                let vm = this;
                vm.messageFilterObj.Units.push(unitObj);
                vm.messageFilterObj.UnitIds.push(unitObj.UnitId.toString());
                vm.messageFilterSearchUnitNameText = null;
                var index = vm.messageUnitList.indexOf(unitObj);

                if (index > -1) {
                    vm.messageUnitList.splice(index, 1);
                }
                // this.GetConversationList(null,"", this.ViewListId);
            },
            messageRemoveUnitFromFilter(unitObj, event) {
                let vm = this;
                var index = vm.messageFilterObj.Units.indexOf(unitObj);
                if (index > -1) {
                    vm.messageFilterObj.Units.splice(index, 1);
                }
                var uidIndex = vm.messageFilterObj.UnitIds.indexOf(unitObj.UnitId.toString());
                if (uidIndex > -1) {
                    vm.messageFilterObj.UnitIds.splice(uidIndex, 1);
                }
                vm.messageUnitList.push(unitObj);

                //this.GetConversationList(null,"", this.ViewListId);
                if (event)
                    event.stopPropagation();
            }
        },
        created() {
            let vm = this;
            vm.$store.state.bus.$on("updatePreviousItem", function (dataobj) {
                if (dataobj && dataobj.conversationId != vm.conversationId && vm.messageFilterType == "notResponded") {
                    let index = vm.messagesList.findIndex(x => x.ConversationId == dataobj.conversationId);
                    if (index > -1) {
                        vm.messagesList[index].IsMessageReplied = true
                    }
                }
            });
        },
        computed: {
            showpDropdownList() {
                setTimeout(function () {
                    $("#propertyDropDownlist").show();
                }, 10);
            },
            getRefreshMessageNotificationPanelStatus() {
                return this.$store.getters.getRefreshMessageNotificationPanel();
            },
        },
        watch: {
            messageFilterSearchUnitNameText(searchText) {
                this.getUnitNamesBySearchText(searchText);
            },
            getRefreshMessageNotificationPanelStatus(oldVal, newVal) {
                console.log(this.getRefreshMessageNotificationPanelStatus);
                if (this.getRefreshMessageNotificationPanelStatus &&
                    this.$route.name == 'MessageInbox'
                ) {
                    this.GetConversationList(null, "", this.ViewListId);
                }
            },
        },
        mounted() {
            let vm = this;
            console.log("messageInbox");
            this.GetConversationList(null, "", this.ViewListId);
            // this.currResObj = { ReservationId: 14169, pagename: "messageInbox" }
            this.GetResevationStatusListBySearchText()
            this.getReservationCustomViews();
            // console.log("store.state == ", this.$store.state.selectedUserDetail.UserId)
            $(this.$el)
                .find("div.dropdown ul.dropdown-menu")
                .click(function (e) {
                    var isTrue = e.target.classList.contains('messageSearchResultsAmenitiesDiv') || e.target.classList.contains('filter') || e.target.classList.contains('SelMesUnitName');

                    if (!isTrue && (e.target.type == undefined || e.target.type != "text")) {
                        vm.messageShowunitNameList = false;
                    }
                    e.stopPropagation();
                });
            $(document).click(function (e) {
                $(".form-control.messageSearchResultsAmenities").hide();
                if (e.target.type == undefined || e.target.type != "text") {
                    vm.messageShowunitNameList = false;
                }
            })
        }
    };
</script>
<style>
    .messageSearchResultsAmenitiesDiv {
        border: 1px solid #ccc;
        display: inline-block !important;
        vertical-align: middle;
        border-radius: 3px;
        width: 303px !important;
        padding: 7px !important;
        line-height: 20px;
        margin-top: -13px;
        left: 10px !important;
    }

    .messageUnitname>.col-md-12>.form-group label {
        margin-top: -6px !important;
        float: left;
        margin-bottom: 0.4em;
    }

    .messageUnitname>.form-group label {
        min-width: 30%;
        font-size: 12px;
        color: #868686;
    }

    .form-control.messageSearchResultsAmenities {
        padding: 0;
        height: unset;
        width: 330px;
    }

    .messageSearchResultsAmenities {
        max-height: 122px;
        overflow-y: scroll;
        width: 100%;
        margin-top: 0px;
        padding: 0px;
        position: absolute;
        z-index: 1;
        /* left: 10px !important; */
    }

    .messageSearchResultsAmenities ul li {
        padding: 10px 15px;
        border-bottom: 1px solid #dfdddd;
        cursor: pointer !important;
    }

    .messageSearchResultsAmenitiesDiv ul.todo-list {
        display: inline;
    }

    .messageSearchResultsAmenitiesDiv .filter>input {
        border: none;
        font-size: 12px;
        outline: none;
        cursor: default !important;
    }

    .messageSearchResultsAmenitiesDiv .filter {
        padding-top: 0px !important;
    }

    .messageUnitname .todo-list li {
        margin-bottom: 0;
        padding: 0;
        margin-right: 15px;
        margin-bottom: 1px !important;
        position: relative;
        top: 3px;
    }

    .messageSearchResultsAmenitiesDiv .todo-list li {
        display: inline-block;
        margin-bottom: 5px !important;
    }

    .messageUnitname .tags span {
        min-width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        padding: 5px 25px 5px 15px;
    }

    .messageSearchResultsAmenitiesDiv .tags span {
        max-width: 280px !important;
        white-space: unset;
        text-overflow: unset;
        overflow: unset;
        display: inline-block;
    }

    .messageSearchResultsAmenitiesDiv .tags span .textOverflowTag {
        display: grid;
        grid-template-columns: 1fr auto;
    }

    .messageSearchResultsAmenitiesDiv .tags span.SelMesUnitName .textOverflowTag p:first-child {
        color: #2d2d2d;
        font-size: 12px;
        max-width: 150px;
        /* min-width: 50px; */
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        float: left;
        margin: 0;
    }

    .messageSearchResultsAmenitiesDiv .tags span.SelMesUnitName .textOverflowTag p:last-child {
        color: #2d2d2d;
        font-size: 12px;
        width: 100%;
        margin: 0;
        display: flex;
        justify-content: flex-end;
    }

    .messageSearchResultsAmenitiesDiv .tags i {
        right: 10px;
        top: 10px !important;
        position: absolute !important;
    }

    .textOverflowTag {
        width: 100%;
    }

    .messageUnitname .tags [class*="fa"] {
        top: -10px;
        position: relative;
    }

    .dropdown.mainDD.custm-dropdown .messageUnit li:first-child~li {
        padding: 0px !important;
    }

    .messageUnit label {
        padding-left: 15px;
    }

    #messageUnitNameDropDown li {
        margin-bottom: 0px !important;
        width: 330px !important;
    }

    .messageUnit li {
        margin-bottom: 5px !important;
    }

    .overflow-scroll li:not(:first-child):hover {
        background-color: white !important;
    }

    .messageSearchResultsAmenities li:hover {
        background-color: white !important;
    }

    .messageSearchResultsAmenitiesDiv li:hover {
        background-color: white !important;
    }

    .messageActionButtons {
        padding-left: 20px !important;
        padding-top: 15px !important;
        border-top: 1px solid #f7f7f7;
        margin-top: -5px;
    }

    .messageActionButtons .btn-danger:focus {
        box-shadow: none !important;
    }

    .message-noresults {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 240px);
    }

    .message-noresults i {
        font-size: 40px;
        color: #f44336;
        opacity: .5;
        margin-bottom: 10px;
    }
</style>